import { useEffect, useState } from "react";
import { ClockCircleOutlined, DoubleLeftOutlined, SearchOutlined, StarOutlined } from "@ant-design/icons";
import SimpleSelect from "@components/simpleSelect/simpleSelect";
import { useDashboardStore } from "@stores/dashboardStore";
import { Button, Input } from "antd";
import classNames from "classnames";
import { filter, forEach, includes, isEmpty, isEqual, map, get, find } from "lodash";

const animationStates = {
  NONE: "none",
  SLIDEIN: "slideIn",
  SLIDEOUT: "slideOut",
};

export const LeftNav = (props: any) => {
  const responseOfApi = useDashboardStore((state) => state.responseOfApi);
  const selectedLob = useDashboardStore((state) => state.selectedLob);
  const setSelectedLob = useDashboardStore((state) => state.setSelectedLob);
  const selectedNavigation = useDashboardStore((state) => state.selectedNavigation);
  const setSelectedNavigation = useDashboardStore((state) => state.setSelectedNavigation);
  const setReportList = useDashboardStore((state) => state.setReportList);
  const searchedKeyWord = useDashboardStore((state) => state.searchedKeyWord);
  const setSearchedKeyWord = useDashboardStore((state) => state.setSearchedKeyWord);
  const [animationStatus, setAnimationStatus] = useState<string>(animationStates.NONE);

  useEffect(() => {
    console.log("LeftNav useEffect", props.open);
    setAnimationStatus(animationStates.SLIDEIN);
  }, [props.open]);

  const handleSlideOut = () => {
    props.handleHideOverlay();
    setAnimationStatus(animationStates.SLIDEOUT);

    setTimeout(() => {
      props.handleButtonClick();
    }, 500);
  };

  return (
    <div
      className={classNames("ui-dashboard-home__leftNavBar", "custom-scroll-bar", "nav-animation", {
        "nav-animation__animate--slide-in": animationStates.SLIDEIN === animationStatus,
        "nav-animation__animate--slide-out": animationStates.SLIDEOUT === animationStatus,
      })}
    >
      {/* search input for the report search */}
      <Input
        onChange={(e) => setSearchedKeyWord(e?.target?.value)}
        value={searchedKeyWord}
        className="ui-dashboard-home__leftNavBar__search"
        placeholder="Enter to Search"
        prefix={<SearchOutlined />}
        size="large"
      />

      {/* recently open reports Button */}
      <div
        className={`ui-dashboard-home__leftNavBar__nav-option ${selectedNavigation?.groupTitle === "Recently Opened" ? "ui-dashboard-home__leftNavBar__nav-option--selected" : ""}`}
        onClick={() => {
          setSelectedNavigation({ groupTitle: "Recently Opened" });

          const list: any[] = [];
          forEach(responseOfApi, (item: any) => {
            forEach(item.options, (option) => {
              forEach(option.groups, (group) => {
                forEach(get(group, "options", []), (_option) => {
                  if (!isEmpty(_option.lastOpenDate)) {
                    list.push(_option);
                  }
                });
              });
            });
          });
          list.sort((a: any, b: any) => new Date(b.lastOpenDate)?.getTime() - new Date(a.lastOpenDate)?.getTime());

          setReportList(list);

          if (props.handleGroupClick) {
            props.handleGroupClick();
          }
        }}
      >
        <ClockCircleOutlined />
        <div className="ui-dashboard-home__leftNavBar__nav-option__title">Recently Opened</div>
      </div>

      {/* Starred Reports Button */}
      <div
        className={`ui-dashboard-home__leftNavBar__nav-option ${selectedNavigation?.groupTitle === "Starred" ? "ui-dashboard-home__leftNavBar__nav-option--selected" : ""}`}
        onClick={() => {
          setSelectedNavigation({ groupTitle: "Starred" });

          const list: any[] = [];
          forEach(responseOfApi, (item: any) => {
            forEach(item.options, (option) => {
              forEach(option.groups, (group) => {
                forEach(get(group, "options", []), (_option) => {
                  if (_option.starred === "Y") {
                    list.push(_option);
                  }
                });
              });
            });
          });

          setReportList(list);

          if (props.handleGroupClick) {
            props.handleGroupClick();
          }
        }}
      >
        <StarOutlined className="ui-dashboard-home__leftNavBar__nav-option__star-size" />
        <div className="ui-dashboard-home__leftNavBar__nav-option__title">Starred</div>
      </div>

      {/* List of the Lobs */}
      <SimpleSelect
        className="ui-dashboard-home__leftNavBar__lob"
        options={responseOfApi}
        value={get(selectedLob, "value", null)}
        handleSelect={(val: string) => {
          const value: any = find(responseOfApi, { value: val });
          setSelectedLob(value);

          setSelectedNavigation(value?.options?.[0]?.groups?.[0]);
          setReportList(value?.options?.[0]?.groups?.[0]?.options);

          if (props.handleGroupClick) {
            props.handleGroupClick();
          }
        }}
      />

      {/* listing groups under the selected options */}
      <div className="ui-dashboard-home__leftNavBar__groups">
        {map(selectedLob?.options, (option: any) => {
          return map(get(option, "groups", []), (item) => {
            const className = classNames("ui-dashboard-home__leftNavBar__groups__name", {
              "ui-dashboard-home__leftNavBar__groups__name--selected": isEqual(item.groupTitle, selectedNavigation.groupTitle),
            });
            const classNameForCount = classNames("ui-dashboard-home__leftNavBar__groups__name__searchCount", {
              "ui-dashboard-home__leftNavBar__groups__name__searchCount--selected": isEqual(item.groupTitle, selectedNavigation.groupTitle),
            });
            const filteredVal: any[] = filter(item?.options, (option) => includes(option.title?.toLowerCase(), searchedKeyWord?.toLowerCase()));

            return (
              // title of the groups of the Lobs
              <div
                key={item.groupValue}
                className={className}
                onClick={() => {
                  setSelectedNavigation(item);
                  setReportList(item?.options);

                  if (props.handleGroupClick) {
                    props.handleGroupClick();
                  }
                }}
              >
                {item.groupTitle}
                {!isEmpty(searchedKeyWord) && filteredVal.length !== 0 && <span className={classNameForCount}>({filteredVal.length})</span>}
              </div>
            );
          });
        })}
      </div>
      {props.handleButtonClick && animationStates.SLIDEOUT !== animationStatus && (
        <Button
          className="ui-dashboard-home__leftNavBar__profile-collapse-btn"
          icon={<DoubleLeftOutlined />}
          size={"middle"}
          onClick={() => {
            handleSlideOut();
          }}
        />
      )}
    </div>
  );
};
